import modalUtils from './modalUtils.js';
import config from './config';
import postData from './postData.js';

class FreecallModal {

  constructor() {
    this.modalUtils = modalUtils

    this.ui = {}
    
    this.ui.modal = document.getElementById("freecall-modal");
    if (!this.ui.modal) return;

    this.ui.successPanel = this.ui.modal.querySelectorAll('.freecall-modal__panel')[0];
    this.ui.successPanelMessage = this.ui.successPanel.querySelector('.freecall-success__message')
    this.ui.formPanel = this.ui.modal.querySelectorAll('.freecall-modal__panel')[1];
    this.ui.form = this.ui.modal.querySelector('.freecall-form');
    this.ui.nameInput = document.getElementById('fc-name');
    this.ui.nameInputError = this.ui.modal.querySelector('#fc-name + .freecall-form__field-error');
    this.ui.phoneInput = document.getElementById('fc-phone');
    this.ui.phoneInputError = this.ui.modal.querySelector('#fc-phone + .freecall-form__field-error');
    this.ui.message = this.ui.modal.querySelector('.freecall-form__message');
    this.ui.sendButton = this.ui.modal.querySelector('.freecall-form__send-btn');

    this.prepare();
    this.prepareTriggers();
  }


  prepare() {
    this.modalUtils.prepareModal(this.ui.modal);

    // устанавливает обработчик на кнопку отправки
    this.ui.sendButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.hideMessage();
      this.unmarkFields();
      if (!this.checkFields()) return;
      this.sendData();
    });

    // сброс информации об ошибках при изменении текста в элементах формы
    [this.ui.nameInput, this.ui.phoneInput].forEach(input => {
      input.addEventListener('input', (e) => {
        input.classList.remove('field-text--invalid')
        this.hideMessage();
      });
    })
  }

  // Очищает поля ввода, приводит форму в исходное состояние
  clearForm() {
    this.showFormPanel();

    [this.ui.nameInput, this.ui.phoneInput].forEach(
      input => {
        input.value = ''
        input.classList.remove('field-text--invalid')
        this.hideMessage()
      })
  }

  // Привязывает окно к вызывающим элементам.
  // Необходима установка следующих атрибутов на вызывающем элементе:
  // - data-modal="freecall-modal" 
  prepareTriggers() {
    const triggers = document.querySelectorAll('[data-modal="freecall-modal"]');
    triggers.forEach(
      trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.clearForm()
          this.modalUtils.showModal(this.ui.modal);
        })
      }
    )
  }


  // open modal
  openModal(modal) {
    this.hideMessage();
    this.enableSendButton();
    this.unmarkFields();
    this.modalUtils.showModal(modal);
  }


  // Отправка данных формы и обработка полученного ответа
  sendData() {
    this.unmarkFields();
    this.hideMessage();
    this.disableSendButton();

    postData({
      url: config.apiUrl,
      data: new FormData(this.ui.form),

      success: (data) => {
        (data.success === true) ?
          this.handleSuccessfulResponse(data) :
          this.handleUnsuccessfullResponse(data);

        this.enableSendButton();
      },

      error: () => {
        this.showMessage('Произошла ошибка при отправке данных');
        this.enableSendButton();
      }
    });
  }


  handleSuccessfulResponse(data) {
    (data.hasOwnProperty('message')) ?
      this.showSuccessPanel(data.message) :
      this.showSuccessPanel('Заявка успешно отправлена!')
  }


  handleUnsuccessfullResponse(data) {
    (data.message) ?
      this.showMessage(data.message) :
      this.showMessage('Произошла ошибка при отправке данных');

    if (
      !data.hasOwnProperty('data') ||
      !data.data.hasOwnProperty('errors')
    ) {
      return
    }

      
    if (data.data.errors.hasOwnProperty('name')) {
      this.showNameFieldError(data.data.errors.name)
    }

    if (data.data.errors.hasOwnProperty('phone')) {
      this.showPhoneFieldError(data.data.errors.phone)
    }
  }



  // показывает сообщение об ошибке
  showMessage(messageText) {
    this.ui.message.classList.add('freecall-form__message--visible');
    this.ui.message.textContent = messageText;
  }


  // возвращает элемент с сообщением об ошибке в изначальное состояние
  hideMessage() {
    this.ui.message.classList.remove('freecall-form__message--visible');
    this.ui.message.textContent = '';
  }

  disableSendButton() {
    this.ui.sendButton.classList.add('loading-button--loading');
    this.ui.sendButton.setAttribute("disabled", "");
  }

  enableSendButton() {
    this.ui.sendButton.classList.remove('loading-button--loading');
    this.ui.sendButton.removeAttribute("disabled");
  }


  isFieldEmpty(field) {
    return (field.value.trim() == "")
  }


  checkFields() {
    if (this.isFieldEmpty(this.ui.nameInput)) {
      this.showNameFieldError('Вы не указали ваше имя')
      this.showMessage('Исправьте ошибки, возникшие при заполнении формы');
      return false;
    }

    if (this.isFieldEmpty(this.ui.phoneInput)) {
      this.showPhoneFieldError('Вы не указали номер телефона')
      this.showMessage('Исправьте ошибки, возникшие при заполнении формы');
      return false;
    }

    return true;
  }


  showNameFieldError(messageText) {
    this.ui.nameInputError.textContent = messageText;
    this.markField(this.ui.nameInput);
  }

  showPhoneFieldError(messageText) {
    this.ui.phoneInputError.textContent = messageText;
    this.markField(this.ui.phoneInput);
  }


  markField(field) {
    field.classList.add('field-text--invalid');
  }


  unmarkFields() {
    [this.ui.nameInput, this.ui.phoneInput].forEach(input => this.unmarkField(input));
  }


  unmarkField(field) {
    field.classList.remove('field-text--invalid');
  }


  showSuccessPanel(messageText) {
    this.ui.successPanelMessage.textContent = messageText
    this.ui.successPanel.classList.add('freecall-modal__panel--visible');
    this.ui.formPanel.classList.remove('freecall-modal__panel--visible');
  }


  showFormPanel() {
    this.ui.successPanel.classList.remove('freecall-modal__panel--visible');
    this.ui.formPanel.classList.add('freecall-modal__panel--visible');
  }


}

export default FreecallModal;